import { render, staticRenderFns } from "./DashboardBusiness.vue?vue&type=template&id=d2e5265c&"
import script from "./DashboardBusiness.vue?vue&type=script&lang=ts&"
export * from "./DashboardBusiness.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardBusiness.vue?vue&type=style&index=0&id=d2e5265c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports